import clsx from 'clsx';
import React from 'react';
import elementType from 'prop-types-extra/lib/elementType';
import { bsClass, getClassSet, splitBsProps } from '../bootstrap/utils/bootstrapUtils';
import { jsx as _jsx } from "react/jsx-runtime";
class ModalFooter extends React.Component {
  render() {
    const {
      componentClass: Component,
      className,
      ...props
    } = this.props;
    const [bsProps, elementProps] = splitBsProps(props);
    const classes = getClassSet(bsProps);
    return /*#__PURE__*/_jsx(Component, {
      ...elementProps,
      className: clsx(className, classes)
    });
  }
}
ModalFooter.defaultProps = {
  componentClass: 'div'
};
export default bsClass('modal-footer', ModalFooter);